/**
 * The snackbar text for a failed delete. A permission refusal from the API carries a message the user
 * can act on ("You do not have permission to delete 2 of the selected deals"), so show it; any other
 * failure shows the caller's generic text.
 */
export function getDeleteErrorMessage(error: any, fallback: string): string {
  const forbidden = error?.graphQLErrors?.find((e: any) => e?.extensions?.code === 'FORBIDDEN')
  return forbidden?.message || fallback
}
